
const commonTheme = {
    //background: "rgba(22, 28, 36, 1)",
    fontFamily:"'Pretendard', sans-serif",
};

export const dashboardTheme = {
    ...commonTheme,
    textColor: 'white',
    fontSize: 20,
    axis: {
        ticks: {
            text: {
                fontSize: 25,
                fill: "white",
            },
        },
        legend: {
            text: {
                fontSize: 28
            },
        },
    },
    legends: {
        text: {
            fontSize: 32,
        },
    },
}

export const itsTheme = {
    ...commonTheme,
}